import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/feature-flags' }, ServiceProxyMap.PPC_BFF);

export const fetchFeatureFlag = async (featureFlagName: string): Promise<{ enabled: boolean }> => {
  const response = await client.get(`/${featureFlagName}`);
  return response.data;
};
